<template>
    <div class="commonTableStyles productionRatio">
        <v-touch @swiperight="swiperright" class="wrapper">
            <div class="contractInfo">
                <van-nav-bar
                    :title="isSee? '配比查看' : '生产配比'"
                    left-text="应用"
                    left-arrow
                    @click-left="onClickLeft"
                >
                    <template #right>
                        <span
                            class="iconfont iconshaixuan1"
                            @click="popupShow=true"
                        ></span>
                    </template>
                </van-nav-bar>
                <section>
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <van-list
                            v-model="isUpLoading"
                            :finished="finished"
                            finished-text="没有更多了!"
                            @load="onLoad"
                        >
                            <ul class="list">
                                <template v-for="(item,index) in listData">
                                    <li :key="index" :class="{'Associated': item.mixture_status == 1,'Uncorrelated': item.mixture_status == 0}">
                                        <div class="engineeringInfo">
                                            <h4 class="engineeringInfo_header">
                                                <span class="state">
                                                    <i v-if="item.mixture_status == 1">已关联</i>
                                                    <i v-if="item.mixture_status == 0">未关联</i>
                                                </span>
                                                <span class="headerName">{{ item.task_number }}</span>
                                                <strong class="contractStatus" style="color:#FF6600;" v-if="item.product_status==0">未排</strong>
                                                <strong class="contractStatus" style="color:#0101B5;" v-else-if="item.product_status==1">待生产</strong>
                                                <strong class="contractStatus" style="color:#00A84B;" v-else-if="item.product_status==2">生产中</strong>
                                                <strong class="contractStatus" style="color:#979ea7;" v-else-if="item.product_status==3">已完成</strong>
                                                <strong class="contractStatus" style="color:#D6010F;" v-else-if="item.product_status==4">暂停</strong>
                                            </h4>
                                            <div class="engineeringInfo_content">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_2.png" alt="">
                                                    <span>工程名称：<i class="wrap-text">{{ item.project_name }}</i></span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_3.png" alt="">
                                                    <span>客户名称：{{ item.customer_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>用料时间：{{ item.arrival_time }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                    <span>施工部位：<i class="wrap-text">{{ item.place_detail }}</i></span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                    <span>产品标号：{{ item.mark_num }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_30.png" alt="">
                                                    <span>任务方量：{{ item.quantity }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                    <span>供应场站：{{ item.station_name }}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="btn-con">
                                            <div class="btn" @click="openCorrelationRatio(item.task_number, index)">
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                {{ isSee? '查看配比' : '关联配比' }}
                                            </div>
                                            <div class="btn" @click="openSeeTestBlock(item.task_number)">
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                查看试块
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </van-list>
                    </van-pull-refresh>
                </section>
            </div>
        </v-touch>
        <!-- 过滤条件 -->
        <van-popup
            class="sideslip"
            v-model="popupShow"
            position="right"
            :style="{ width: '80%',height: '100%' }"
        >
            <div class="screen">
                <van-nav-bar
                    title="筛选"
                    right-text="取消"
                    @click-right="onClickRight"
                >
                </van-nav-bar>
                <section>
                    <dl>
                        <dt>搜索条件</dt>
                        <dd>
                            <van-field v-model="Keywords" placeholder="请输入搜索信息"></van-field>
                        </dd>
                    </dl>
                    <dl>
                        <dt>配比状态</dt>
                        <dd>
                            <span
                                :class="{'active': activeMixtureStatus===item.code}"
                                v-for="(item) in mixtureStatus"
                                :key="`mixture_${item.code}`"
                                @click="activeMixtureStatus=item.code"
                            >
                                {{ item.name }}
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>生产状态</dt>
                        <dd>
                            <span
                                :class="{'active': activeProductStatus===item.code}"
                                v-for="(item) in productStatus"
                                :key="`product_${item.code}`"
                                @click="activeProductStatus=item.code"
                            >
                                {{ item.name }}
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>强度等级</dt>
                        <dd>
                            <span
                                :class="{'active': activeLevelStatus===item.code}"
                                v-for="(item) in levelStatus"
                                :key="`level_${item.code}`"
                                @click="activeLevelStatus=item.code"
                            >
                                {{ item.name }}
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>场站</dt>
                        <dd>
                            <span
                                :class="{'active': activeStation===item.station_id}"
                                v-for="(item) in stationData"
                                :key="`level_${item.station_id}`"
                                @click="activeStation=item.station_id"
                            >
                                {{ item.name }}
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>用料时间</dt>
                        <dd>
                            <van-field
                                readonly
                                v-model="calendarData"
                                placeholder="请选择时间段"
                                @click="calendarShow = true"
                            ></van-field>
                        </dd>
                    </dl>
                </section>
                <div class="bottom">
                    <div class="sure-btn" @click="search">
                        确定
                    </div>
                    <div class="reset-btn" @click="handleReset">
                        重置
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 选择时间段 -->
        <van-calendar
            type="range"
            color="#1989fa"
            :min-date="minDate"
            v-model="calendarShow"
            @confirm="onConfirmCalendar"
        ></van-calendar>
    </div>
</template>
<script>
export default {
    name: 'production-ratio',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'production-ratio');
        }
        next();
    },
    data() {
        return {
            // 搜索条件
            value: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 上拉索引
            count: 0,
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
            // 任务状态颜色
            taskSAtatus: '#FF6600',
            // 搜索条件
            popupShow: false,
            // 配比状态
            mixtureStatus: [
                { code: -1, name: '全部' },
                { code: 0, name: '未关联' },
                { code: 1, name: '已关联' },
            ],
            activeMixtureStatus: -1,
            productStatus: [
                { code: -1, name: '全部' },
                { code: 0, name: '未排' },
                { code: 1, name: '待生产' },
                { code: 2, name: '生产中' },
                { code: 3, name: '已完成' },
                { code: 4, name: '暂停' },
                { code: 5, name: '已关闭' },
                { code: 6, name: '已取消' },
            ],
            activeProductStatus: -1,
            levelStatus: [
                { code: -1, name: '全部' },
                { code: 0, name: '高标号' },
                { code: 1, name: '普通标号' },
            ],
            activeLevelStatus: -1,
            Keywords: '',
            // 场站数据
            stationData: [
                { name: '全部', station_id: '' },
            ],
            activeStation: '',
            // 查看状态
            isSee: false,
            // 选择时间段
            calendarShow: false,
            minDate: new Date(1990, 1, 1),
            calendarData: '',
            startTime: '',
            endTime: '',
        };
    },
    created() {
        if (this.$route.query.see) {
            this.isSee = this.$route.query.see;
        }
        // 拉取场站
        this.getStation();
    },
    mounted() { },
    activated() {
        // 发送成功更新关联状态
        if (this.$route.params.index) {
            this.listData[this.$route.params.index].mixture_status = 1;
        }
    },
    update() { },
    beforeRouteUpdate() { },
    methods: {
        // 拉取场站
        async getStation() {
            const station = await this.getStationApi();
            if (station) {
                this.stationData.push(...station);
            }
        },
        // 选择时间段
        onConfirmCalendar(date) {
            const [start, end] = date;
            this.calendarShow = false;
            this.startTime = this.formatDate(start);
            this.endTime = this.formatDate(end);
            this.calendarData = `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
        },
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        // 搜索
        search() {
            this.count = 1;
            this.listData = [];
            this.finished = false;
            // 获取关联配比列表数据
            this.getInit();
            this.popupShow = false;
        },
        // 重置查询条件
        handleReset() {
            this.Keywords = '';
            this.activeLevelStatus = -1;
            this.activeMixtureStatus = -1;
            this.activeProductStatus = -1;
            this.startTime = '';
            this.endTime = '';
            this.calendarData = '';
            this.activeStation = '';
        },
        // 取消
        onClickRight() {
            this.handleReset();
            this.popupShow = false;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.finished = false;
            this.getInit();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.getInit();
        },
        // 打开关联配比/查看配比
        openCorrelationRatio(task_number, index) {
            this.$router.isBack = 2;
            let pushName = '';
            if (this.isSee) {
                pushName = 'correlationRatio_see';
            } else {
                pushName = 'correlationRatio';
            }
            this.$router.push({
                name: pushName,
                params: {
                    isSee: this.isSee,
                    task_number: task_number,
                    listIndex: index,
                },
            });
        },
        // 打开查看试块
        openSeeTestBlock(task_number) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'seeTestBlock',
                params: {
                    task_number: task_number,
                },
            });
        },
        // 获取关联配比列表数据
        getInit() {
            const url = '/interfaceApi/production/productformula/query_taskformula?'
                      + `searchValue=${this.Keywords}&`
                      + `pageindex=${this.count}&`
                      + `mixture_status=${this.activeMixtureStatus}&`
                      + `product_status=${this.activeProductStatus}&`
                      + `station_id=${this.activeStation}&`
                      + `level=${this.activeLevelStatus}&`
                      + `pagesize=3&is_rel_formula=${!this.isSee}&`
                      + `startTime=${this.startTime}&`
                      + `endTime=${this.endTime}`;
            this.$axios
                .get(url)
                .then(res => {
                    this.total = res.total;
                    if (this.listData.length < 1) {
                        this.listData = res.rows;
                        this.finished = false;
                    } else {
                        this.listData.push(...res.rows);
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取场站
        async getStationApi() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationLs = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                return stationLs;
            }
            return [];
        },
    },
    filter: {},
    computed: {},
    watch: {},
};
</script>

<style lang="stylus">
.productionRatio
    height 100%
    .contractInfo,
    .wrapper
        height 100%
        .iconshaixuan1
            font-size 20rpx
            color #ffffff
            margin-right 10rpx
        section
            height calc(100% - 45rpx)
            .van-pull-refresh
                height 100%
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
                .list
                    height calc(100% - 45rpx)
                    overflow-y auto
                    background #F0F0F0
                    padding 0 15rpx
                    padding-bottom 0
                    li
                        width 100%
                        background #fff
                        overflow hidden
                        margin-bottom 15rpx
                        position relative
                        position relative
                        &:first-child
                            margin-top 15rpx
                        .engineeringInfo
                            .telephone
                                width 25rpx
                                height 25rpx
                                background url(./../../../assets/images/clueManagement/phone@2x.png)
                                background-size 100% 100%
                                border none
                                position absolute
                                right 15rpx
                                bottom 25rpx
                        .btns
                            margin-bottom 10rpx
                        &.Associated
                            h4
                                .state
                                    background-color #FF6600
                        &.Uncorrelated
                            h4
                                .state
                                    background-color #979EA7
    .screen
        height 100%
        section
            height calc(100% - 85rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            dd
                margin-top 8rpx
                display flex
                flex-wrap wrap
                .van-field
                    border 1px solid #ddd
                    padding 6rpx 10rpx
                >span
                    width calc(33.33% - 10rpx)
                    background #F1F1F1
                    border 1px solid #F1F1F1
                    border-radius 6rpx
                    margin 0 10rpx 10rpx 0
                    font-size 14rpx
                    text-align center
                    padding 6rpx 0
                    &:last-child
                        margin-right 0
                    &.active
                        border 1px solid #E60000
                        color #E60000
                        background #fff
                        position relative
                        &:after
                            position absolute
                            content ''
                            bottom 0
                            right -1px
                            width 20rpx
                            height 20rpx
                            background url(./../../../assets/images/contractInfo/pick.png) no-repeat
                            background-size 100% 100%
        .bottom
            height 40rpx
            display flex
            font-size 18rpx
            text-align center
            line-height 40rpx
            .sure-btn
                flex 1
                background #E60000
                height 100%
                border 1px solid #E60000
                color #fff
            .reset-btn
                flex 1
                height 100%
                border 1px solid #E60000
                color #E60000
</style>
